class Modal {
  constructor(modalContainer,modalButton) {
    this.modalConatiner = document.querySelector(modalContainer);
    this.modalButton = document.querySelector(modalButton);
  }

  toggleEvent() {
    if (this.modalButton) {
      this.modalButton.addEventListener('click', () => {
        let navCategories = document.querySelector('.js-categories-container');
        let navCategoriesCurrentState = navCategories.classList.contains('js-nav-off');
        let subNavContainer = document.querySelectorAll('.menu-item-has-children');

        if (navCategoriesCurrentState === false) {
          navCategories.classList.add('js-nav-off');

          let navChildList = navCategories.querySelector('.nav');
          navChildList.classList.remove('animated');
          navChildList.classList.remove('slideInLeft');
        }

        subNavContainer.forEach((el) => {
          if (el.classList.contains('js-nav-on')) {
            el.classList.remove('js-nav-on');

            let elActive = el.querySelector('.sub-menu');

            elActive.classList.remove('js-subnav-on');
            elActive.classList.remove('animated');
            elActive.classList.remove('fadeInUp');
          }
        });

        this.modalConatiner.classList.toggle('phone-modal-off');
        this.modalConatiner.classList.toggle('animated');
        this.modalConatiner.classList.toggle('fadeIn');
      })
    }
  }
}

export default Modal;


// WEBPACK FOOTER //
// ./scripts/modules/modal.js